var __TEMP__ = require('./_arrayFilter.js');var arrayFilter = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isFunction.js');var isFunction = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.functions` which creates an array of
 * `object` function property names filtered from `props`.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} props The property names to filter.
 * @returns {Array} Returns the function names.
 */
function baseFunctions(object, props) {
  return arrayFilter(props, function(key) {
    return isFunction(object[key]);
  });
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseFunctions;
